export enum DepositStatus {
    PENDING = 'pending',
    CONFIRMED = 'confirmed',
    FAILURE = 'failure',
}
